import { ChangeDetectionStrategy, Component, inject, model, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ListViewTemplateListItem } from './list-view-template-list-item/list-view-template-list-item'
import { TemplateStateService } from '../../services/template-state.service'
import { ContentSidebarListViewComponent } from '../content-sidebar-list-view/content-sidebar-list-view.component'

@Component({
  selector: 'albert-listview-template',
  standalone: true,
  imports: [CommonModule, ListViewTemplateListItem, ContentSidebarListViewComponent],
  templateUrl: './list-view-template.component.html',
  styleUrl: './list-view-template.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewTemplateComponent implements OnInit {
  public readonly itemSize = 195
  public readonly sidebarDrawerVisible = model(false)
  public readonly templateState = inject(TemplateStateService)

  public ngOnInit(): void {
    this.templateState.reload(20).subscribe()
  }
}
